export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReENVW5pS1MtVVRGMzItSEMLAAAgFr59DgefbSCDnW0ACgQBACwMAQABAB43gQQ8YwcAACATAb57n2wBvngFCb8BAgG+f4OdcgG/DRAFvxE7Ar8a", "base64")


//////////////////
// WEBPACK FOOTER
// ./src/components/vue-pdf/src/buffer-loader.js!./node_modules/pdfjs-dist/cmaps/UniKS-UTF32-V.bcmap
// module id = PQtb
// module chunks = 0